declare const dataLayer: Array<Record<string, unknown>>;

interface EventData {
  eventName: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  timestamp?: string;
  // Additional event specific payload (e.g. products, type), pushed as is.
  [key: string]: unknown;
}

/* eslint-disable no-console */
const getDataLayer = (): Array<Record<string, unknown>> | null => {
  if (typeof window === 'undefined') {
    console.warn(
      'running a non-browser environment (SSR?) - no dataLayer available',
    );
    return null;
  }

  if (typeof dataLayer === 'undefined') {
    console.warn('DataLayer is not defined');
    return null;
  }

  return dataLayer;
};

/**
 * Resets the given event variables to null. GTM merges every push into a
 * single state, so variables of a previous event stay in memory and would be
 * reported again with the next one (e.g. a second assistant submitted on the
 * same page). Call this right before pushing an event carrying those
 * variables.
 */
export const resetEventData = (keys: string[]) => {
  const layer = getDataLayer();
  if (!layer) {
    return;
  }

  const resetData: Record<string, unknown> = {};
  keys.forEach((key) => {
    resetData[key] = null;
  });

  layer.push(resetData);
};

export const sendEvent = (data: EventData) => {
  console.log(`pushed event: ${data.eventName}`);
  const layer = getDataLayer();
  if (!layer) {
    return;
  }

  const { eventName, ...rest } = data;

  layer.push({
    event: eventName,
    timestamp: new Date().toISOString(),
    ...rest,
  });
};
/* eslint-enable no-console */
